import { render } from "./TopicWorlds.vue?vue&type=template&id=ded1e8b6"
import script from "./TopicWorlds.vue?vue&type=script&lang=js"
export * from "./TopicWorlds.vue?vue&type=script&lang=js"

import "./TopicWorlds.vue?vue&type=style&index=0&id=ded1e8b6&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__